const featuresConstant = [
    { id: 1, title: '學習隱密性', line1: '', line2: '', src: require('../static/adult/private.png') },
    { id: 2, title: 'CEFR國際分級', line1: '', line2: '', src: require('../static/adult/global.png') },
    { id: 3, title: '堅持純正師資', line1: '', line2: '', src: require('../static/adult/teacher.png') },
    { id: 4, title: '課程方案親民', line1: '', line2: '', src: require('../static/adult/book.png') },
]

export default ({ sub_features = featuresConstant, title = "讓孩子有效且快樂的學習，讓家長放心" }) => (
    <article id="sub_feature">
        <h1>{title}</h1>
        <ul>
            {
                sub_features.map((item) =>
                (
                    <li key={item.id} className="list-img-wrapper">
                        <div className="list-img-a">
                            <img
                                key={`img-${item.id}`}
                                src={item.src}
                                alt={item.title}
                            />
                        </div>
                        <div className="list-content-a">
                            <h3>{item.line1}</h3>
                            <h3>{item.line2}</h3>
                        </div>
                    </li>
                ))
            }
        </ul>
        <style jsx>{`
      article {
        background-color: #f7f7f7;
        padding-bottom: 5%;
      }

      h1 {
        text-align: center;
        font-size: 2em;
        font-weight: bold;
        padding: 5% 0 2%;
        color: #0070C0;
      }

      ul {
        list-style: none;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin: 50px 5%;
      }

      li {
        display: flex;
        flex-direction: row;
        align-self: flex-start;
        width: 30%;
        padding: 0.5em 0 3em;
      }
      
      .list-img-wrapper {
          width: 180px;
          float: left;
          align-items: center;
          display: flex;
          flex-direction: column;
      }
      
      .list-img-a {
        width: 130px;
      }
      
      .list-content-a {
        width: 140px;
        position: relative;
        float: left;
        text-align: center;
      }
      
      .list-content-a h3 {
        margin: 0.5em 0;
        color: #393e46;
        font-size: 1.4em;
        font-weight: bold;
      }

      @media(max-width: 768px){
        article {
          padding-bottom: 2em;
        }

        h1 {
          padding: 1.5em 1em 1em;
        }

        ul {
          margin: 0em 0em;
        }

        li {
          width: 100%;
          margin: 5px;
          padding: 0em 0 0em;
        }
        
        .list-img-wrapper {
            width: 150px;
        }
      }
      
      @media(max-width: 640px){
          text-align: left;
      }
    `}</style>
    </article>
)